module.exports = __webpack_public_path__ + "static/img/1.3b3384a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/sp/1.png
// module id = dZkm
// module chunks = 0